"use client";

import { Paragraph } from "@app/_components/ui";
import * as Accordion from "@radix-ui/react-accordion";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

import { cn } from "@/lib/utils";

import type { IN_STOCK_ITEM } from "../Stock.types";
import { type StockStatusProps } from "../Stock.types";
import StockDialog from "../StockDialog";
import StockIndicator from "./StockIndicator";

export default function InStockItem({
  status,
  config,
}: {
  status: IN_STOCK_ITEM;
  config: StockStatusProps;
}) {
  const [popup, setPopup] = useState<boolean>(false);
  const { type, item, className, stockInfo, dictionary, ...props } = config;
  if (type === "pdp") {
    return (
      <>
        <Accordion.Root type="multiple" className={cn("text-sm", className)}>
          <Accordion.Item value={item?.id ?? "1"} {...props}>
            <Accordion.Header asChild>
              <div className="inline-flex flex-wrap items-start gap-2">
                <StockIndicator status={status} />
                <span className="inline-block">
                  <strong className="font-medium">
                    {dictionary?.inStockXPiecesLeft?.replace(
                      "%X%",
                      status.pretty,
                    )}
                    {", "}
                  </strong>
                  {dictionary?.shipsWithinDays?.replace("%X%", "1-3")}
                </span>
                {/**
                 * If stock is "unlimited" we don't want an accordion
                 */}
                {status.quantity === Infinity ? (
                  <button
                    className="inline-flex items-center underline"
                    onClick={() => setPopup(true)}
                  >
                    {dictionary?.readMore}
                  </button>
                ) : (
                  <Accordion.Trigger className="group inline-flex items-center gap-1 whitespace-nowrap underline">
                    {dictionary?.moreInfo}
                    <ChevronDown className="h-3 w-3 transition-all group-data-[state=closed]:rotate-0 group-data-[state=open]:rotate-180" />
                  </Accordion.Trigger>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Content className="mt-2 overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
              <Paragraph className="text-gray-500">
                {dictionary?.stockItemExplanation?.replace(
                  "%X%",
                  status?.date ?? new Date().getFullYear().toString(),
                )}{" "}
                {stockInfo && (
                  <button
                    className="text-black underline"
                    onClick={() => setPopup(true)}
                  >
                    {dictionary?.readMore}
                  </button>
                )}
              </Paragraph>
            </Accordion.Content>
          </Accordion.Item>
        </Accordion.Root>
        {stockInfo && (
          <StockDialog
            open={popup}
            onClose={() => setPopup(false)}
            block={stockInfo}
          />
        )}
      </>
    );
  }
  return (
    <div
      className={cn(
        "inline-flex items-start gap-2 text-xxs uppercase",
        className,
      )}
      {...props}
    >
      <StockIndicator status={status} />
      <span className="inline-block">{dictionary?.inStock}</span>
    </div>
  );
}
